export default function FloatingContent() {
  const block = document.querySelectorAll<HTMLDivElement>(".js-floating-content");

  block.forEach((item) => {
    const closeBtn = item.querySelector<HTMLButtonElement>(".js-close-btn");
    const Id = item.getAttribute("data-id");

    const handleSetCookie = (cname: string, cvalue: string) => {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1); // add 1 year
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${cname}=${cvalue};${expires};path=/`;
    };

    const handleCloseMenBar = () => {
      item.setAttribute("data-open", "false");

      if (Id) {
        handleSetCookie(`alert-${Id}`, Id);
      }
    };

    if (closeBtn) {
      closeBtn.addEventListener("click", handleCloseMenBar);
    }
  });
}
